module.exports = __webpack_public_path__ + "assets/wg.94824975.svg";